import { useEffect } from "react";
import CustomSelect from "../customSelect/CustomSelect";
import { documentCategories, maxFileSize } from "../../data/data";

const DocumentUpload = ({ selectedDocumentFile, setSelectedDocumentFile, selectedCategory, setSelectedCategory, inputKey, setValidationErrors }) => {

    const handleFileSelection = (files) => {
        setValidationErrors([]);

        const validFiles = Array.from(files).filter(
            (file) =>
                [
                    'application/pdf', // .pdf
                    'application/msword', // .doc
                    'application/vnd.oasis.opendocument.text', // .odt
                    'application/vnd.openxmlformats-officedocument.wordprocessingml.document' // .docx
                ].includes(file.type) &&
                file.size <= maxFileSize // Deafault max file size set in data.js
        );

        if (validFiles.length === 0) {
            setValidationErrors(['Invalid file type or file size exceeds allowed limit.'])
        }

        const filePreviews = validFiles.map((file) => ({
            file: file,
            filename: file.name, 
            category: selectedCategory?.type ? selectedCategory.type : 'Uncategorized',
        }));
    
        setSelectedDocumentFile((prev) => {
            const updatedFile = {...prev, ...filePreviews[0]};
            return updatedFile;
        });
    };
    

    const handleDocumentChange = (event) => {
        const files = event.target.files;
        if (files) {
            handleFileSelection(files);
        }
    };

    const handleDrop = (event) => {
        event.preventDefault();
        const files = event.dataTransfer.files;
        if (files) {
            handleFileSelection(files);
        }
    };

    const handleRemoveFile = (index) => {
        setSelectedDocumentFile((prev) => {
            const updatedFiles = prev.filter((_, i) => i !== index);
            return updatedFiles;
        });
    };

    const handleDocumentTypeChange = (option) => {
        setSelectedCategory(option);
        const selectedDocumentType = documentCategories.find((doc) => doc.type === option.type);
        console.log('SELECTED DOCUMENT TYPE: ', selectedDocumentType);
        if (selectedDocumentType && selectedDocumentFile?.filename) {
            setSelectedDocumentFile(prev => ({
                ...prev, category: selectedDocumentType?.type || 'uncategorized',
            }));
        }
    }

    return (
        <div key={inputKey} className="doc-upload" onClick={() => console.log('Clicked key', inputKey)}>
            <label className="label">Doc upload</label>

            <input
                key={inputKey}
                type="file"
                multiple
                accept="application/pdf, application/msword, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                onChange={handleDocumentChange}
                style={{ display: "none" }}
                id={`doc-input-${inputKey}`}
            />
            <label className="upload-label" htmlFor={`doc-input-${inputKey}`} style={{ cursor: "pointer" }}>
                <p className="upload-text"> {selectedDocumentFile?.filename ? selectedDocumentFile.filename : "Select File"}</p>
            </label>

            {setSelectedCategory && 
                <CustomSelect
                    name="doc-category"
                    placeholder="Select Category"
                    options={documentCategories}
                    labelKey="name"
                    setSelectedOption={(option) => handleDocumentTypeChange(option)}
                    selectedOption={selectedCategory} // Default selection
                />
            }
        </div>
    );
};

export default DocumentUpload;
